<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row">
      <div class="col-form-label col-sm-12" v-if="fbhidelabel !== 'true'">
        
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b> {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>

      <div class="col-sm-12">
        <div class="form-check-wrapper" :class="{ invalid: !isValid }">
          <div ref="fboptions"  v-for="option in fboptions" class="form-check"  :key="option.Key">
            <label class="form-check-label">
              <input type="radio" class="form-check-input-styled" :name="id" :value="option.Value" @change="dataChanged" :checked="option.Key === d" :disabled="checkReadonly(isedit, fbreadonly)"/>
              {{ option.Key }}
            </label>
          </div>
        </div>
        <!-- <input v-if="fbreadonly == 'true'" type="text" class="form-control" :value="valueText" >
        <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('ui.SYS00016') }}</label> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RadioBox',
  props: ['id', 'fbsupportmultiplelanguages','fblabel', 'value', 'fbvalue', 'fboptions', 'fbreadonly', 'fbrequired', 'labelwidth', 'fbhidelabel', 'isedit', "fbinvisible"],
  data () {
    return {
      d: null,
      isValid: true
    }
  },
  mounted () {
    //this.initRadio()

    this.$emit('input', this.fbvalue, this);  //vue componenet value
    if(this.value != null){
      $(this.$el).find(':radio[value="' + this.value + '"]').prop('checked', true)
    }
  },
  computed: {
    valueText () {
      var v = null
      if (this.d) {
        $.each(this.options, $.proxy(function (i, o) {
          if (this.d === o.Key) {
            v = o.Value
            return false
          }
        }, this))
      }

      return v
    },
    labelCol () {
      return this.labelwidth || 3
    }
  },
  methods: {
    setFocus () {
      $(this.$el).find(':radio').filter(':first').focus()
    },
    checkReadonly(isedit, fbreadonly) {
      let readonly = true;
      if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }

      return readonly;
    },
    setValid (val) {
      this.isValid = val
    },
    isFieldValid () {
      return !this.fbrequired || (this.fbrequired && this.d !== null && this.d !== undefined && this.d !== '')
    },
    dataChanged (e) {
      this.d = $(e.target).val()
      this.$emit('input', this.d, this)
    },
    resetValue () {
      this.isValid = true
      $(this.$el).find(':radio').prop('checked', false)
    },
    initRadio () {
      $(this.$refs.options).find('.form-check-input-styled').uniform({
        wrapperClass: 'border-success-600 text-success-800'
      })
    }
  },
  watch: {
    value: function (val) {
      this.d = val
      $(this.$el).find(':radio').prop('checked', false);
      console.log($(this.$el).find(':radio'));
      $(this.$el).find(':radio[value="' + val + '"]').prop('checked', true)
      this.setValid(this.isFieldValid())
    }
  }
}
</script>
